import React from "react"

import { Switch, Route } from "client/components"
import * as routes from "client/parts/routes"

import AccessDenied from "client/parts/accessDenied"
import ProfileView from "client/parts/profile/view"
import ProfileEdit from "client/parts/profile/edit"

import MtAccount from "client/pages/mt/account"
import MtBilling from "client/pages/mt/billing"
import MtPackage from "client/pages/mt/package"
import MtPermissions from "client/pages/mt/permissions"
import MtModule from "client/pages/mt/module"
import MtUser from "client/pages/mt/user"
import MtGroup from "client/pages/mt/group"
import MtTag from "client/pages/mt/tag"
import MtTranslations from "client/pages/mt/translations"
import MtSqlExecutor from "client/pages/mt/sqlExecutor"

import Settings from "client/pages/settings"
import CloudDriveAuthResponse from "client/pages/settings/drive/response"
import Project from "client/pages/project/project"
import Task from "client/pages/task"
import Drive from "client/pages/drive"

import CcLibrary from "client/pages/cc/library"
import CcFixComplianceAnswer from "client/pages/cc/fixComplianceAnswer"

import Lifecycle from "client/pages/lifecycle"

import MarkovHome from "client/pages/markov/home"
import MarkovModel from "client/pages/markov/model"

import SilDevice from "client/pages/sil/device"

import QidCompany from "client/pages/qid/company"
import QidProduct from "client/pages/qid/product"

import OkrSession from "client/pages/okr/session"

import RrsCategory from "client/pages/rrs/category"
import RrsTemplate from "client/pages/rrs/template"

export const ContentExpired = () => (
    <Switch>
        <Route exact path={routes.profileRoute} component={ProfileView} />
        <Route exact path={routes.profileEditRoute} component={ProfileEdit} />

        <Route exact path={routes.mtRoute} component={MtHome} />
        <Route path={routes.mtBillingRoute} component={MtBilling} />
        <Route path="/" component={AccessDenied} />
    </Switch>
)

export const Content = () => (
    <Switch>
        <Route exact path={routes.profileRoute} component={ProfileView} />
        <Route exact path={routes.profileEditRoute} component={ProfileEdit} />

        <Route exact path={routes.mtRoute} component={MtHome} />
        <Route path={routes.mtAccountsRoute} component={MtAccount} />
        <Route path={routes.mtAccountRoute} component={MtAccount} />
        <Route path={routes.mtBillingRoute} component={MtBilling} />
        <Route path={routes.mtPackagesRoute} component={MtPackage} />
        <Route path={routes.mtPermissionsRoute} component={MtPermissions} />
        <Route path={routes.mtGroupsRoute} component={MtGroup} />
        <Route path={routes.mtUsersRoute} component={MtUser} />
        <Route path={routes.mtModulesRoute} component={MtModule} />
        <Route path={routes.mtTagsRoute} component={MtTag} />
        <Route path={routes.mtSettingsRoute} component={Settings} />
        <Route path={routes.cloudDriveAuthResponseRoute} component={CloudDriveAuthResponse} />
        <Route path={routes.mtTranslationsRoute} component={MtTranslations} />
        <Route path={routes.mtSqlRoute} component={MtSqlExecutor} />

        <Route path={routes.projectsRoute} component={Project} />
        <Route path={routes.tasksRoute} component={Task} />
        <Route path={routes.driveRoute} component={Drive} />

        <Route exact path={routes.ccRoute} component={CcHome} />
        <Route path={routes.ccComplianceSetsRoute} component={CcLibrary} />
        <Route path={routes.ccFixComplianceAnswer} component={CcFixComplianceAnswer} />

        <Route exact path={routes.silRoute} component={SilHome} />
        <Route path={routes.silDevicesRoute} component={SilDevice} />
        <Route path={routes.silSubsystemsRoute} component={SilDevice} />

        <Route exact path={routes.qidRoute} component={QidHome} />
        <Route path={routes.qidCompaniesRoute} component={QidCompany} />
        <Route path={routes.qidProductsRoute} component={QidProduct} />

        <Route exact path={routes.lifecycleRoute} component={LifecycleHome} />
        <Route path={routes.lifecyclesRoute} component={Lifecycle} />

        <Route exact path={routes.markovRoute} component={MarkovHome} />
        <Route path={routes.markovModelsRoute} component={MarkovModel} />

        <Route exact path={routes.okrRoute} component={OkrHome} />
        <Route path={routes.okrSessionsRoute} component={OkrSession} />

        <Route exact path={routes.rrsRoute} component={RrsHome} />
        <Route path={routes.rrsCategoriesRoute} component={RrsCategory} />
        <Route path={routes.rrsTemplatesRoute} component={RrsTemplate} />
    </Switch>
)

const MtHome = () => (<div>Mt Home</div>)
const CcHome = () => (<div>CC Home</div>)
const SilHome = () => (<div>SIL Home</div>)
const QidHome = () => (<div>QID Home</div>)
const LifecycleHome = () => (<div>Lifecycle Home</div>)
const OkrHome = () => (<div>OKR Home</div>)
const RrsHome = () => (<div>Rrs Home</div>)
